import { Component } from '@angular/core';

@Component({
  selector: 'app-main-payments-menu',
  templateUrl: './main-payments-menu.component.html',
  styleUrls: ['./main-payments-menu.component.css'],
})
export class MainPaymentsMenuComponent {}
